<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você pode conferir todos os investidores cadastrados até o
              momento. Toda nova conta criada aparecerá automaticamente na
              tabela abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col">
          <div
            class="card shadow table-container vld-parent"
            ref="investors_table"
          >
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">
                    Lista de <span class="text-orange">investidores</span>
                    <span
                      class="bg-white text-dark rounded border px-2 py-1 float-right font-weight-normal text-sm"
                      >{{ tableData.length }} investidores ao total</span
                    >
                  </h3>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <base-table
                class="table align-items-center table-flush"
                thead-classes="thead-light"
                tbody-classes="list"
                :data="tableData"
              >
                <template slot="columns">
                  <th>#</th>
                  <th>Investidor</th>
                  <th>Email usuário</th>
                  <th>Localização</th>
                  <th>Local de trabalho</th>
                  <th>Ações</th>
                </template>
                <template slot-scope="{ row, index }">
                  <td>
                    <span>{{ index + 1 }}</span>
                  </td>
                  <td>
                    <router-link
                      :to="`/admin/investidores/${row.user.id}/editar`"
                      class="btn btn-link px-0"
                    >
                      {{ row.name }}
                    </router-link>
                    <badge
                      v-if="row.account_validated"
                      type="success"
                      title="A conta do investidor está validada. Certifique-se de vinculá-lo a pelo menos um fundo de investimentos"
                    >
                      <i class="fas fa-info-circle mr-1"></i>
                      Conta validada
                    </badge>
                    <badge
                      v-else
                      type="warning"
                      title="Enquanto a conta não for validada o investidor não terá acesso as funcionalidades do portal"
                    >
                      <i class="fas fa-info-circle mr-1"></i>
                      Conta não validada
                    </badge>
                  </td>
                  <td>{{ row.user.email }}</td>
                  <td>{{ row.city }}, {{ row.state }}</td>
                  <td>
                    <span :title="row.occupation">{{
                      row.working_place || "-"
                    }}</span>
                  </td>
                  <td>
                    <router-link
                      :to="'/admin/investidores/' + row.user.id + '/editar'"
                      title="Editar investidor"
                      class="btn btn-white py-1 px-2"
                      ><i class="fas fa-edit text-info"></i
                    ></router-link>
                    <span
                      @click="handleOpenModalConfirmation(row)"
                      title="Deletar investidor"
                      class="btn btn-white py-1 px-2 cursor-pointer"
                    >
                      <i class="fas fa-trash text-red"></i>
                    </span>
                  </td>
                </template>
              </base-table>
              <p v-if="empty" class="text-center text-warning mt-3">
                Não há investidores até o momento
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.modalConfirmation"
      gradient="dark"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="py-3 text-center">
          <i class="fa fa-trash fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja excluir o investidor
            <span class="text-warning">{{ modals.investorName }}</span
            >?
          </h4>
          <p class="mt-3 mb-0">
            Todas as informações relacionadas ao investidor
            <span class="text-warning">{{ modals.investorName }}</span> ({{
              modals.investorEmail
            }}) serão perdidas.
          </p>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="handleCloseModalConfirmation"
        >
          Voltar
        </base-button>
        <base-button
          type="white text-danger"
          @click="handleSubmitRemoveInvestor"
        >
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "investor_table",
  data() {
    return {
      tableData: [],
      empty: false,
      modals: {
        modalConfirmation: false,
        investorName: "",
        investorEmail: "",
        investorId: null,
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.investors_table,
      width: 90,
      height: 90,
    });
    try {
      const { data } = await api.get("/adm/investors");
      if (data.length) this.tableData = data;
      else this.empty = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar os invetidores");
    }
  },
  methods: {
    handleOpenModalConfirmation(investor) {
      this.modals.investorId = investor.user.id;
      this.modals.investorName = investor.name;
      this.modals.investorEmail = investor.user.email;
      this.modals.modalConfirmation = true;
    },
    handleCloseModalConfirmation() {
      this.modals.modalConfirmation = false;
      this.modals.investorId = null;
      this.modals.investorName = "";
      this.modals.investorEmail = "";
    },
    async handleSubmitRemoveInvestor() {
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0,
      });
      try {
        await api.delete(`/adm/investors/${this.modals.investorId}`);
        this.$toasted.show("Investidor removido com sucesso");
        this.$router.go();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao remover o investidor");
      } finally {
        loader.hide();
      }
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 150px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
